import { BuyerIntentLeadClick } from 'components/BuyerIntent';
import Card from 'components/Card';
import CtaButton from 'components/CtaButton';
import Grid from 'components/Grid';
import Typography from 'components/Typography';
import { useEventContext } from 'context/EventContext';
import { useListingDetailContext } from 'context/ListingDetailContext';
import usePplForm from 'hooks/usePplForm';

import advisorsImg from './assets/advisors.png';

import classes from './PPLPricingBanner.module.scss';

/** @type {import("./types").default} */
const PPLPricingBanner = ({
  show,
  title = "Confused about pricing? We've got you covered.",
  description = 'Get a personalized pricing breakdown tailored to your specific needs, no guesswork, no generic estimates.',
  ctaLabel = 'Get Price',
  sourceLocation = 'listing-detail/pricing-plans:get-price',
  engagementDetails = 'pricing-plans_get-price',
  formTemplate = 'price',
}) => {
  const { addEvent } = useEventContext();
  const { listing } = useListingDetailContext() ?? {};

  const { buyerIntentProductId, buyerIntentCategoryId, handleClick } =
    usePplForm({
      productId: listing?.global_product_id,
      sourceLocation,
      formTemplate,
      includeProductInConfig: formTemplate === 'price',
      enabled: !!show,
    });

  if (!show) return null;

  const content = (
    <Card className={classes.card} elevation={1}>
      <Grid container={true} alignItems="center" className={classes.inner}>
        <Grid item={true} className={classes.advisors}>
          {/* biome-ignore lint/nursery/noImgElement: static asset, no Next.js Image needed */}
          <img src={advisorsImg.src} alt="" />
        </Grid>
        <Grid item={true} xs={true} className={classes.text}>
          <Typography variant="h3" className={classes.heading}>
            {title}
          </Typography>
          <Typography className={classes.description}>{description}</Typography>
        </Grid>
        <Grid item={true}>
          <CtaButton
            onClick={handleClick}
            {...addEvent({
              engagementComponent: 'ppl_banner',
              engagementDestination:
                formTemplate === 'price'
                  ? 'go-to_ppl-price-form'
                  : 'go-to_ppl-faststart-form',
              engagementDetails: engagementDetails,
              name: 'ppl_cta',
            })}
          >
            {ctaLabel}
          </CtaButton>
        </Grid>
      </Grid>
    </Card>
  );

  return (
    <BuyerIntentLeadClick
      productId={buyerIntentProductId}
      categoryId={buyerIntentCategoryId}
      sourceLocation={sourceLocation}
    >
      <div className={classes.root}>{content}</div>
    </BuyerIntentLeadClick>
  );
};

export default PPLPricingBanner;
